import React, { useState, useRef } from 'react'
import '../../_css/AddExcelModal.css'
import { addExcelTeachers } from '../../requests'
import { notifySuccess, notifyError, notifyWarning } from '../../utils/helper'
import { useDispatch } from 'react-redux'
import { startLoader } from '../../_store/reducers/loaderReducer'
import { stopLoader } from '../../_store/reducers/loaderReducer'

const AddExcelModal = ({ onClose }) => {

  const [csvfile, setcsvfile] = useState(null);
  const dispatch = useDispatch()
  const [isDragging, setIsDragging] = useState(false)
  const fileInputRef = useRef(null)

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = () => {
    setIsDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragging(false)
    
    const files = Array.from(e.dataTransfer.files)
    const csvFile = files.find(file => 
      file.type === 'text/csv' || 
      file.name.endsWith('.csv') ||
      file.type === 'application/vnd.ms-excel' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    )
    
    if (csvFile) {
      setcsvfile(csvFile)
    } else {
      alert('Please upload a CSV file')
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      if (
        file.type === 'text/csv' || 
        file.name.endsWith('.csv') ||
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setcsvfile(file)
      } else {
        notifyError("Please upload a CSV file");
      }
    }
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleRemove = (e) => {
    e.stopPropagation()
    setcsvfile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleUpload = async () => {
    dispatch(startLoader())

    if(!csvfile){
        notifyError("Please upload a CSV file");
        return;
    }
    try {

        const formData = new FormData();
        formData.append('excel', csvfile);
        const response = await addExcelTeachers(formData);
        if(response.status < 400){
          if(response?.data?.invalid_row_numbers?.length > 0){
            notifyWarning("Teachers added successfully. But some rows are invalid. Invalid rows: " + response?.data?.invalid_row_numbers?.join(", "),20000);
            
          }else{
            notifySuccess(response?.data?.message || "Teachers added successfully");
          }
            onClose();
            setcsvfile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = ''
            }
        }
    } catch (error) {
        console.log(error);
        notifyError(error?.response?.data?.error || "Something went wrong");
        
    } finally {
        dispatch(stopLoader())
    }
  }

  const handleClose = () =>{
    onClose();
    setcsvfile(null);
    if (fileInputRef.current) {
        fileInputRef.current.value = ''
    }
  }

  return (
    <div className="excel-modal-overlay" onClick={handleClose}>
      <div className="excel-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="excel-modal-head">
          <div className="excel-modal-head-text">Upload CSV File</div>
          <img
            style={{ cursor: "pointer" }}
            onClick={handleClose}
            src="/close.svg"
            alt="Close"
          />
        </div>
        
        <div className="excel-modal-body">
          <div
            className={`excel-upload-area ${isDragging ? 'dragging' : ''} ${csvfile ? 'has-file' : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={!csvfile ? handleClick : undefined}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept=".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            
            {csvfile ? (
              <div className="excel-file-info">
                <div className="excel-file-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#01a7de" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="#01a7de" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="#01a7de" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="#01a7de" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H9H8" stroke="#01a7de" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="excel-file-details">
                  <div className="excel-file-name">{csvfile.name}</div>
                  <div className="excel-file-size">
                    {(csvfile.size / 1024).toFixed(2)} KB
                  </div>
                </div>
                <button 
                  className="excel-remove-btn"
                  onClick={handleRemove}
                  type="button"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#ef4848" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            ) : (
              <>
                <div className="excel-upload-icon">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 10L12 15L17 10" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 15V3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="excel-upload-text">
                  <div className="excel-upload-title">Drag and drop your CSV file here</div>
                  <div className="excel-upload-subtitle">or click to browse</div>
                </div>
                <div className="excel-upload-hint">
                  Supported formats: CSV, Excel (.xlsx, .xls)
                </div>

               
              </>
            )}
          </div>
        </div>
        <div className="excel-upload-hint" style = {{color: '#01a7de', cursor: 'pointer',textAlign: 'center',paddingBottom: '10px',fontSize: '14px'}}>
                 <a href="/Book1.xlsx" download>Download teacher data template</a>
                </div>
        
        <div className="excel-modal-footer">
          
          <button className="excel-cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button 
            className="excel-submit-btn" 
            onClick={handleUpload}
            disabled={!csvfile}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddExcelModal
